import { SkillStatesLabel } from '../models/SkillState';
import { StudentSkillStates } from '../models/StudentSkillState';
import { mapSkillStatus } from './mapSkillStatus';

const passedSkills = [SkillStatesLabel.PASSED, SkillStatesLabel.PLACED_OUT];

export const onlyNotPassed = (element: StudentSkillStates) => {
  const { status } = mapSkillStatus(element.skillSubstate.id, element.skillAssessment?.score);
  return passedSkills.includes(status as SkillStatesLabel) ? false : true;
};
